<template>
	<div class="myPolicyPush">
		<div v-loading="loading" class="news-list">
			<template v-if="usePushPolicyList.length">
				<div v-for="(item, index) in usePushPolicyList" :key="index" class="news-item">
					<!-- 内容 -->
					<div class="news-content">
						<h3>{{ item.policyTitle }}</h3>
						<p :title="item.policyContent">{{ item.policyContent }}</p>
						<div class="meta">
							<div class="meta-info">
								<span>
									<i class="el-icon-document"></i>
									{{ policyTypeDict.find(i => i.dictCode === item.policyType)?.dictValue }}
								</span>
								<span>
									<i class="el-icon-time"></i>
									{{ item.createTime }}
								</span>
							</div>
							<div v-if="token" class="actions"></div>
						</div>
					</div>
				</div>
			</template>

			<!-- 数据为空 -->
			<empty-content v-else empty-text="暂无推送信息"></empty-content>

			<!-- 未登录 -->
			<nonbind-user v-if="!token"></nonbind-user>
		</div>

		<!-- 分页 -->
		<div v-if="usePushPolicyList.length" class="pagination-container">
			<jr-pagination
				:limit="pageOptions.limit"
				:page.sync="pageOptions.page"
				:total="pageOptions.total"
				layout="prev, pager, next"
				prev-text="上一页"
				next-text="下一页"
				@change="handlePaginationChange"
			></jr-pagination>
		</div>
	</div>
</template>

<script>
	import NonbindUser from '@/components/NonBind/nonbindUser'
	import JrPagination from '@/components/Pagination'
	import { pageUserSubscribePolicyByType } from '@/api/userCenter/index'
	import { mapGetters } from 'vuex'
	import { mapDictionaries } from '@/store/dictionary-helper'

	//政策快讯-平台推送
	export default {
		name: 'MyPolicyPush',
		components: {
			NonbindUser,
			JrPagination
		},
		props: {},
		data() {
			return {
				// 用户被推送的政策资讯信息
				usePushPolicyList: [],
				// 加载状态
				loading: false,
				// 分页配置
				pageOptions: {
					limit: 10,
					page: 1,
					total: 0
				}
			}
		},
		computed: {
			...mapGetters(['token']),
			// 使用自定义的映射函数
			...mapDictionaries('dictionary', ['policyTypeDict'])
		},
		watch: {},
		created() {
			if (this.token) {
				this.getUserPushPolicyList()
			}
		},
		mounted() {},
		methods: {
			// 查询用户收藏的政策资讯信息
			getUserPushPolicyList() {
				this.loading = true

				const params = {
					page: this.pageOptions.page,
					size: this.pageOptions.limit,
					...this.queryParams
				}

				pageUserSubscribePolicyByType(params)
					.then(response => {
						const { data } = response
						if (data && data.records) {
							this.usePushPolicyList = data.records
							this.pageOptions.total = data.total || 0
						} else {
							this.usePushPolicyList = []
							this.pageOptions.total = 0
						}
						this.loading = false
					})
					.catch(() => {
						this.loading = false
						this.usePushPolicyList = []
						this.pageOptions.total = 0
					})
			},

			// 分页变化
			handlePaginationChange(pager) {
				const { page, limit } = pager
				this.pageOptions.page = page
				this.pageOptions.limit = limit
				this.getUserPushPolicyList()
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/policy/styles/policy.scss';
	.myPolicyPush {
		min-height: 500px;
	}
</style>
